function f(r) {
  const e = r.filter((n) => n !== void 0);
  if (e.length !== 0)
    return e.length === 1 ? e[0] : (n) => {
      r.forEach((t) => {
        t && t(n);
      });
    };
}
export {
  f as mergeEventHandlers
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/merge-handlers.js
// module id = 902
// module chunks = 41